import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import './CTAV2.css';

export const CTAV2 = ({
  component: Component = 'a',
  color = 'blue',
  children,
  arrow = true,
  larger = false,
  bold = false,
  className,
  ...props
}) => {
  const classes = cx(
    'cta-v2',
    { 'cta-v2--larger': larger },
    { 'cta-v2--blue': color === 'blue' },
    { 'cta-v2--white': color === 'white' },
    { 'cta-v2--with-arrow': arrow },
    { 'cta-v2--bold': bold },
    className
  );
  return (
    <Component className={classes} {...props}>
      {children}
    </Component>
  );
};

CTAV2.propTypes = {
  component: PropTypes.oneOf(['a', 'button']),
  color: PropTypes.oneOf(['blue', 'teal', 'white']),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  arrow: PropTypes.bool,
  larger: PropTypes.bool,
  bold: PropTypes.bool,
  className: PropTypes.string,
};

export default CTAV2;
